export enum EditorDisplayType {
	ActiveVersion = 0,
	ReadonlyVersion = 1,
	Instance = 2,
}

export type WorkflowSettings = {
	enabled: boolean
}